/**
 * 功能：生成图形验证码
 * 帮助文档：http://manage.captcha.oa.com/captcha/index.html#/gettingStart
 */

/* 配置 */
const APP_ID = '2079606977';
const SDK_SRC = 'https://ssl.captcha.qq.com/TCaptcha.js';

/**
  调用示例：

  // 引用库
  import captcha from '@/lib/TCaptcha';

  // 具体事件中调用
  captcha.show({
    callback: (res) => {
      if (res.ret === 2) {
        // 用户主动关闭验证码
        return;
      }

      if (res.ret !== 0) {
        console.log(`${res.errorMessage}。错误码：${res.errorCode}`);
        return;
      }

      // 请求接口
      reqApi({
        ticket: res.ticket,
        randstr: res.randstr,
      });
    },
  });
 */
const captcha = {
  captchaInstance: null,

  /*
    callback 示例
    res（验证成功） = {ret: 0, ticket: "String", randstr: "String"}
    res（客户端出现异常错误 仍返回可用票据） = {ret: 0, ticket: "String", randstr: "String", errorCode: Number, errorMessage: "String"}
    res（用户主动关闭验证码）= {ret: 2}

    function callback(res) {
      if (res.ret === 2) {
        // 用户主动关闭验证码
        return;
      }

      if (res.ret !== 0) {
        console.log(`${res.errorMessage}。错误码：${res.errorCode}`);
        return;
      }

      // 请求接口
      reqApi({
        ticket: res.ticket,
        randstr: res.randstr,
      });
    }
  */
  init({
    callback,
    options = {},
  }) {
    if (typeof callback !== 'function') {
      console.log('[TCaptcha组件] 请指定回调方法');
      return;
    }

    const retPromise = new Promise((resolve, reject) => {
      if (window.TencentCaptcha) {
        this.create({ callback, options });
        resolve(this);
        return;
      }

      loadScript(SDK_SRC)
        .then(() => {
          this.create({ callback, options });
          resolve(this);
        })
        .catch(() => {
          const errorInfo = {
            ret: 0,
            randstr: `@${Math.random().toString(36)
              .substr(2)}`,
            ticket: `terror_1001_${APP_ID}_${Math.floor(new Date().getTime() / 1000)}`,
            errorCode: 1001,
            errorMessage: 'jsload_error',
          };
          callback(errorInfo);
          reject(errorInfo);
        });
    });

    return retPromise;
  },

  // 创建实例
  create({
    callback,
    options = {},
  }) {
    this.captchaInstance = new window.TencentCaptcha(APP_ID, callback, options);
  },

  // 显示图形验证码
  show({
    callback,
    options = {},
  }) {
    // 初始化并显示验证码
    this.init({ callback, options })
      .then(() => {
        this.captchaInstance.show();
      });
  },

  // 隐藏图形验证码
  destroy() {
    if (this.captchaInstance !== null) {
      this.captchaInstance.destroy();
      return;
    }

    console.log('[TCaptcha组件] 请先初始化 captcha.init');
  },
};

// 加载script脚本
function loadScript(src) {
  const retPromise = new Promise((resolve, reject) => {
    let scriptNode = document.createElement('script');
    scriptNode.src = src;
    scriptNode.onload = function () {
      resolve();
    };
    scriptNode.onerror = function (error) {
      reject(error);
    };
    document.body.appendChild(scriptNode);
    scriptNode = null;
  });
  return retPromise;
}

export default captcha;
